import { useDisclosure } from '@mantine/hooks'
import { Button } from '@seen/ui'
import type { JSX } from 'react'
import { useParams } from 'react-router'
import { AddAdmission } from '#src/components/admission/AddAdmission.tsx'
import { AdmissionTable } from '#src/components/admission/AdmissionTable.tsx'

export function PatientAdmissionsPage(): JSX.Element {
  const { patientId } = useParams()
  const [showCreateModal, { open: openCreateModal, close: closeCreateModal }] =
    useDisclosure(false)

  return (
    <>
      <div className="flex justify-end">
        <Button variant="outline" onClick={openCreateModal}>
          Add Admission
        </Button>
      </div>
      <AdmissionTable
        patientId={patientId}
        pagePrefix={`/Patient/${patientId}/admissions`}
      />
      <AddAdmission
        open={showCreateModal}
        onOpenChange={(setOpen) => {
          if (setOpen) {
            openCreateModal()
          } else {
            closeCreateModal()
          }
        }}
      />
    </>
  )
}
